import { Section as BaseSection } from '../../utils/theme';
import styled, { keyframes } from 'styled-components';

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  overflow: hidden;
  height: 45vw;

  @media (max-width: 600px) {
    height: 45vw;
  }
`;

export const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(1.1);
  }
`;

export const BackgroundImage = styled.img`
  z-index: -10;
  position: absolute;
  top: -3vw;
  left: 0vw;
  width: 100vw;
  min-height: 57vw;

  animation: ${pulsing} 20s infinite ease-in-out;

  @media (max-width: 600px) {
    position: absolute;
    left: 0vw;
    top: 0vw;
    width: 100vw;
  }
`;

export const Countdown = styled.div`
  position: absolute;
  display: flex;
  justify-content: left;
  top: 20vw;
  left: 62vw;
  width: 28vw;
  margin: 1vw 0vw;
  scale: 160%;

  @media (max-width: 600px) {
    position: absolute;
    display: flex;
    justify-content: center;
    top: 10vw;
    left: 25vw;
    width: 50vw;
    scale: 100%;
  }
`
